import type { Lesson } from '@court-sync/shared';
import { getLessonCourtIds } from '@court-sync/shared';

/**
 * Whether a lesson belongs to a location for schedule filtering.
 * Uses explicit `lesson.locationId` when set; otherwise infers from assigned courts.
 */
export function lessonMatchesScheduleLocationFilter(
  lesson: Lesson,
  filterLocationId: string | undefined | null,
  courts: ReadonlyArray<{ id: string; locationId?: string | null }>
): boolean {
  if (!filterLocationId) return true;
  if (lesson.locationId && String(lesson.locationId).length > 0) {
    return lesson.locationId === filterLocationId;
  }
  return getLessonCourtIds(lesson).some((cid) => {
    const c = courts.find((x) => x.id === cid);
    return c?.locationId === filterLocationId;
  });
}
